namespace advisorop.components.servicer {


    export class CuFirmTampController {

        public dgTamps: DevExpress.ui.dxDataGridOptions;
        selTampType: domains.ILOV;
        user: domains.identity.IUser;
        servicer: any;
        advisoryFirmId: number;
        showTampProductPanel: boolean = false;

        tampTypes: domains.ILOV[] = [];
        tamp: domains.ITamp = {};
        tamps: Array<domains.IAdvisoryFirmTamp> = [];


        // tamp products
        selFirmProduct: domains.IAdvisoryFirmProduct = {};
        firmProducts: domains.IAdvisoryFirmProduct[];
        tampProduct: domains.ITampProduct = {};
        tampProducts: domains.ITampProduct[] = [];


        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService)
        {
            
            this.dgTamps = {
                export: {
                    enabled: true,
                    fileName: "Tamps"
                },
                bindingOptions: {
                    dataSource: "vm.tamps"
                    //"columns[1].lookup.dataSource": "vm.tampTypes"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no tamps",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { name: "tampname1", dataField: "tampName", caption: "Name", cellTemplate: "colFullName" },
                    { dataField: "tampTypeName", caption: "Type" },
                    { dataField: "tampName", caption: "Name", cellTemplate: "colStatus" },
                    //{
                    //    dataField: "type", caption: "Type",
                    //    lookup: {
                    //        dataSource: this.tampTypes,
                    //        valueExpr: "value", displayExpr: "name"
                    //    }
                    //},
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "150"}
                ]
            };
        }
        

        assignTamp(tamp: domains.IAdvisoryFirmTamp): void {
            let tmpTamp = tamp;
            tamp.advisoryFirmId = this.advisoryFirmId;
            this.servicerService.assignFirmTamp(tamp)
                .then((response) => {
                    toastr.success("Tamp successfully assigned.");
                    this.loadFirmTamps();
                    this.cleanInputs();
                },err => toastr.error("Tamp has not been assigned! " + err.data));
        };

        unassignTamp(tamp: domains.IAdvisoryFirmTamp): void {

            var x = this.tamps;

            if (!window.confirm("Are you sure ?"))
                return;

            this.servicerService.unassignFirmTamp(tamp.id).
                then((response) => {
                    toastr.success("Tamp has been successfully unassigned.");
                    this.loadFirmTamps();
                    this.cleanInputs();
                }).
                catch(err => {
                    toastr.error("Cannot unassign this tamp! " + err.data);
                });
        };

        editTamp(tamp: domains.IAdvisoryFirmTamp): void {

            if (!(tamp.advisoryFirmId && tamp.advisoryFirmId > 0))
                return;

            this.servicerService.getTampsById(tamp.tampId)
                .then( response => {
                    this.tamp = response.data;
                    this.loadTampProducts();
                }).catch(err => {
                    toastr.error("Cannot fetch tamp");
                })
        };

        cleanInputs(): void {
            this.tamp = {};
            this.cancelAssignProduct();
        };
        
        
        loadFirmTamps(): void {
            this.servicerService.getFirmTamps(this.advisoryFirmId)
                .then((response) => {
                    this.tamps = response.data;
                    this.dgTamps.dataSource = this.tamps;
                })
                .catch(err => {
                    toastr.error("Cannot fetch tamps!");
                });
        };

        // #region TampProducts
        loadFirmProducts(): void {
            this.servicerService.getFirmProducts(this.advisoryFirmId)
                .then(response => this.firmProducts = response.data, err => toastr.error("Product list can not be loaded. " + err.data));
        };
        loadTampProducts(): void {
            this.servicerService.getTampProducts(this.tamp.id)
                .then(response => this.tampProducts = response.data, err => toastr.error("Tamp products could not been loaded. " + err.data));
        };
        firmProductChanged(): void {
        };
        newProduct(): void {
            // reloading...
            this.loadFirmProducts();
            this.showTampProductPanel = true;
        };
        assignProduct(): void {
            let tampProduct: domains.ITampProduct = {
                advisoryFirmId: this.advisoryFirmId,
                tampId: this.tamp.id,
                advisoryFirmProductId: this.selFirmProduct.id,
                productName: this.selFirmProduct.name
            };

            this.servicerService.createTampProduct(tampProduct)
                .then(response => {
                    if (this.tampProducts.map(m => m.id).indexOf(response.data.id) >= 0)
                    {
                        toastr.success("Tamp product has already assigned");
                        return;
                    }
                    this.tampProducts.push(response.data);
                    toastr.success("Tamp product has been successfully assigned");
                }, err => err => toastr.error("Tamp product has not been added. " + err.data));
        };
        removeProduct(tampProduct: domains.ITampProduct): void {
            this.servicerService.deleteTampProduct(tampProduct.id)
                .then(response => {
                    var ind = this.tampProducts.map(m => m.id).indexOf(response.data.id);
                    if (ind >= 0) {
                        this.tampProducts.slice(ind, 1);
                    };
                    toastr.success("Tamp product has been successfully unassigned");
                    this.loadTampProducts();
                }, err => toastr.error("Tamp product has not been unassigned. " + err.data));
        };
        cancelAssignProduct(): void {
            this.selFirmProduct = null;
            this.showTampProductPanel = false;
        }
        // #endregion


        loadLovs(): void {
            this.generalService.getLOVs()
                .then( data => {
                    this.tampTypes = (<domains.ILOV[]>data).filter( v => { return v.lovType == domains.LovType.TAMP_TYPE; });
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            this.loadLovs();
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "advisoryFirmId") {
                    if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                        this.loadFirmProducts();
                        this.loadFirmTamps();
                    }
                }
            }
        }
    }


    class CuFirmTamp implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<"
            };
            this.controller = CuFirmTampController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-firm-tamp.html";
        }
    }
    angular.module(Constants.APP).component("cuFirmTamp", new CuFirmTamp());
}